import Marquee from "react-fast-marquee";
import { useI18n } from "@/i18n";

export function Ribbon() {
  const { t } = useI18n();
  return (
    <div className="border-y border-white/10 bg-[#0a0a0a] py-5 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {t.ribbon.map((txt, i) => (
          <span key={i} className="flex items-center">
            <span className="font-clash font-black uppercase text-2xl md:text-4xl tracking-tight text-[#f5f5f5] mx-8">
              {txt}
            </span>
            <span className="text-[#ff4500] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
